import React from "react";
import { Heart, Camera, ChefHat, Sparkles, History } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const features = [{
  title: "Artistry",
  description: "We approach every frame with a painterly eye, ensuring your wedding gallery feels like a curated collection of fine art.",
  icon: Sparkles
}, {
  title: "Presence",
  description: "Our unobtrusive approach allows us to capture the quiet, fleeting moments of genuine emotion without disrupting your day.",
  icon: Heart
}, {
  title: "Legacy",
  description: "We create timeless imagery that transcends fleeting trends, preserving your story for generations to come with elegant clarity.",
  icon: History
}, {
  title: "Intimacy",
  description: "By building a personal connection, we capture the unique vulnerability and soft-toned romance that defines your specific bond.",
  icon: Camera
}];
export default function WhyHabeshaPastry() {
  return <section data-section-id="223936" id="our-values" className="relative py-24 md:py-32 bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <span className="text-[25rem] md:text-[40rem] font-default leading-none text-primary/5 italic">
          I
        </span>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
            Our Values
          </h2>
          <p className="text-lg text-muted-foreground font-default italic">
            The philosophy behind every shutter click and curated frame.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <Card key={i} data-index={i} className="bg-card/40 backdrop-blur-md border-border/40 shadow-sm hover:shadow-lg transition-all duration-500 group rounded-md">
                <CardHeader className="pb-4">
                  <div className="w-12 h-12 rounded-md bg-accent/50 flex items-center justify-center mb-4 group-hover:bg-accent transition-colors">
                    <Icon className="w-5 h-5 text-primary" strokeWidth={1} />
                  </div>
                  <CardTitle className="font-default font-semibold text-2xl text-foreground tracking-tight">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed font-sans text-base">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}